import { render, staticRenderFns } from "./VuesticIconRich.vue?vue&type=template&id=d40195c4"
import script from "./VuesticIconRich.vue?vue&type=script&lang=js"
export * from "./VuesticIconRich.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconRich.vue?vue&type=style&index=0&id=d40195c4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d40195c4')) {
      api.createRecord('d40195c4', component.options)
    } else {
      api.reload('d40195c4', component.options)
    }
    module.hot.accept("./VuesticIconRich.vue?vue&type=template&id=d40195c4", function () {
      api.rerender('d40195c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-icon/VuesticIconRich.vue"
export default component.exports